import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import Lottie from "lottie-react";
import PropTypes from "prop-types";
import React from "react";
import { Modal, Button } from "react-bootstrap";
import animationData from "assets/img/animated-icons/warning-light.json";
const ConfirmationModal = ({
  modal,
  setModal,
  onConfirm,
  title,
  description,
}) => {
  return (
    <Modal show={modal} centered dialogClassName="wizard-modal">
      <Modal.Body>
        <FalconCloseButton
          size="sm"
          className="position-absolute top-0 end-0 me-2 mt-2"
          onClick={() => setModal(!modal)}
        />
        <Flex justifyContent="center" alignItems="center">
          <Lottie
            animationData={animationData}
            loop={true}
            style={{ width: "100px" }}
          />
          <div className="mb-0 flex-1 d-flex flex-column">
            <h6 className="fs-9 text-700">{title}</h6>
            <h6 className="fs-11 text-400">{description}</h6>
          </div>
        </Flex>
        <hr />
        <div className="d-flex justify-content-center align-items-center gap-3">
          <Button variant="danger" size="sm" onClick={() => setModal(false)}>
            Cancel
          </Button>
          <Button
            variant="success"
            size="sm"
            onClick={() => {
              onConfirm();
              setModal(false);
            }}
          >
            Confirm
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  modal: PropTypes.bool.isRequired,
  setModal: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmationModal;
